(function () {
  'use strict';

  var INVALID_CLASS = 'cart__terms-consent--invalid';

  function findConsentForForm(form) {
    if (!form || !form.id) return null;
    var scoped = document.querySelector('[data-terms-consent][data-terms-consent-form="' + form.id + '"]');
    if (scoped) return scoped;
    return form.querySelector('[data-terms-consent]');
  }

  function showError(consent) {
    if (!consent) return;
    consent.classList.add(INVALID_CLASS);
    var error = consent.querySelector('[data-terms-consent-error]');
    if (error) error.hidden = false;
  }

  function clearError(consent) {
    if (!consent) return;
    consent.classList.remove(INVALID_CLASS);
    var error = consent.querySelector('[data-terms-consent-error]');
    if (error) error.hidden = true;
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var consent = findConsentForForm(form);
    if (!consent) return;
    var input = consent.querySelector('[data-terms-consent-input]');
    if (!input || input.checked) {
      clearError(consent);
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    showError(consent);
    try {
      input.focus({ preventScroll: false });
    } catch (e) {
      input.focus();
    }
  }

  function handleCheckoutClick(event) {
    var trigger = event.target.closest('[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!trigger) return;
    var formId = trigger.getAttribute('form');
    var form = formId ? document.getElementById(formId) : trigger.closest('form');
    if (!form) return;
    var consent = findConsentForForm(form);
    if (!consent) return;
    var input = consent.querySelector('[data-terms-consent-input]');
    if (!input || input.checked) {
      clearError(consent);
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    showError(consent);
    try {
      input.focus({ preventScroll: false });
    } catch (e) {
      input.focus();
    }
  }

  function handleChange(event) {
    var input = event.target.closest('[data-terms-consent-input]');
    if (!input) return;
    var consent = input.closest('[data-terms-consent]');
    if (input.checked) clearError(consent);
  }

  document.addEventListener('submit', handleSubmit, true);
  document.addEventListener('click', handleCheckoutClick, true);
  document.addEventListener('change', handleChange, false);
})();
